export const GOOGLE_FONT_OPTIONS = [
  'Raleway',
  'Roboto',
  'Open Sans',
  'Montserrat',
  'Poppins',
  'Inter',
  'Lato',
  'Nunito',
  'Oswald',
  'Playfair Display',
  'Merriweather',
  'Source Sans 3',
  'DM Sans',
  'Work Sans',
  'Rubik',
  'Bebas Neue',
  'Space Grotesk',
  'Archivo',
  'Manrope',
  'Josefin Sans',
  'Quicksand',
  'Cormorant Garamond'
];

export const DEFAULT_TYPOGRAPHY = {
  bodyFont: 'Raleway',
  headingFont: 'Raleway',
  accentFont: 'Raleway'
};

export const buildGoogleFontsUrl = (fonts = []) => {
  const uniqueFonts = [...new Set(fonts.filter(Boolean))];

  if (uniqueFonts.length === 0) {
    return '';
  }

  const families = uniqueFonts
    .map(font => `family=${font.trim().replace(/\s+/g, '+')}:wght@300;400;500;600;700;800`)
    .join('&');

  return `https://fonts.googleapis.com/css2?${families}&display=swap`;
};

export const fontStack = (font) => `"${font || DEFAULT_TYPOGRAPHY.bodyFont}", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif`;
